<template>
  <div class="container-fluid p-2 order-create">
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    >
    </loading>
    <h5 class="text-muted mr-auto p-2">
      <h2 v-if="order.status === 'new'">{{ $t("buttons.beginOrder") }}</h2>
      <h2 v-else-if="order.status === 'edit'">
        {{ $t("buttons.editOrder") }} - <small>{{ order.increment_id }}</small>
        <br />
      </h2>
      <h2 v-else-if="order.status === 'create'">
        {{ $t("buttons.createInvoice") }}
      </h2>
      <h2 v-else-if="order.status === 'createInvoice'">
        {{ $t("buttons.createInvoice") }}
      </h2>

      <small>
        {{ order.customer.cardCode }} - {{ order.customer.company }}
      </small>
    </h5>
    <validation-observer
      v-if="showDocumentAddressForm && order.status == 'new'"
      ref="v-observer-address-additional"
      class="row"
    >
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-4 col-12">
            <div class="input-group mb-3">
              <label class="input-group-text" for="specialAddress">{{
                $t("orders.specialAddress")
              }}</label>
              <div class="input-group-prepend">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="specialAddress"
                  @change="changeSpecialAddressForm"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="order.specialAddressForm === 'Y'" class="col-sm-12">
        <div class="row ">
          <div class="col-sm-6 col-12">
            <validation-provider v-slot="v" slim rules="required">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <label class="input-group-text" for="addressName">{{
                    $t("customer.addressName")
                  }}</label>
                </div>
                <input
                  id="addressName"
                  type="text"
                  name="addressName"
                  :value="order.addressForm.addressName"
                  class="form-control"
                  :class="{
                    'is-invalid': v.errors.length,
                  }"
                  @input="changeAddressFormName($event.target.value)"
                />
              </div>
            </validation-provider>
          </div>
          <div class="col-sm-6 col-12">
            <validation-provider v-slot="v" slim rules="required">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <label class="input-group-text" for="city">{{
                    $t("customer.city")
                  }}</label>
                </div>
                <input
                  id="city"
                  type="text"
                  name="city"
                  :value="order.addressForm.city"
                  class="form-control"
                  :class="{
                    'is-invalid': v.errors.length,
                  }"
                  @input="changeAddressFormCity($event.target.value)"
                />
              </div>
            </validation-provider>
          </div>
          <div class="col-sm-6 col-12">
            <validation-provider v-slot="v" slim rules="required">
              <div class="input-group-prepend mb-3">
                <label class="input-group-text" for="street">{{
                  $t("customer.street")
                }}</label>

                <input
                  class="form-control w-100"
                  maxlength="100"
                  type="text"
                  id="street"
                  :value="order.addressForm.street"
                  :class="{
                    'is-invalid': v.errors.length,
                  }"
                  @input="changeAddressFormStreet($event.target.value)"
                />
              </div>
            </validation-provider>
          </div>
          <div class="col-sm-6 col-12">
            <validation-provider v-slot="v" slim rules="required">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <label class="input-group-text" for="zipCode">{{
                    $t("customer.postcode")
                  }}</label>
                </div>
                <input
                  id="zipCode"
                  type="text"
                  name="zipCode"
                  :value="currentAddressForm.zipCode"
                  class="form-control"
                  :class="{
                    'is-invalid': v.errors.length,
                  }"
                  @input="changeAddressFormZipCode($event.target.value)"
                />
              </div>
            </validation-provider>
          </div>
          <div class="col-sm-6 col-12">
            <validation-provider v-slot="v" slim rules="required">
              <div class="input-group-prepend mb-3">
                <label class="input-group-text" for="country">{{
                  $t("customer.country")
                }}</label>

                <select
                  id="countryId"
                  :value="order.addressForm.country"
                  :placeholder="$t('customer.country')"
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': v.errors.length,
                  }"
                  @input="changeAddressFormCountry($event.target.value)"
                >
                  <option
                    v-for="country in countryList"
                    :key="country.code"
                    :value="country.code"
                  >
                    {{ locale === "pl" ? country.namepl : country.nameen }}
                  </option>
                </select>
              </div>
            </validation-provider>
          </div>
          <div class="col-sm-6 col-12">
            <validation-provider v-slot="v" slim rules="required">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <label class="input-group-text" for="phone">{{
                    $t("customer.personPhone")
                  }}</label>
                </div>
                <input
                  id="phone"
                  type="text"
                  name="phone"
                  :value="order.addressForm.phone"
                  class="form-control"
                  :class="{
                    'is-invalid': v.errors.length,
                  }"
                  @input="changeAddressFormPhone($event.target.value)"
                />
              </div>
            </validation-provider>
          </div>
          <div class="col-sm-6 col-12">
            <validation-provider v-slot="v" slim rules="required">
              <div class="input-group-prepend mb-3">
                <label class="input-group-text" for="email">{{
                  $t("customer.email.index")
                }}</label>

                <input
                  class="form-control w-100"
                  maxlength="100"
                  type="text"
                  id="street"
                  :value="order.addressForm.email"
                  :class="{
                    'is-invalid': v.errors.length,
                  }"
                  @input="changeAddressFormEmail($event.target.value)"
                />
              </div>
            </validation-provider>
          </div>
          <div v-if="visibleSubsidiaries" class="col-sm-6 col-12">
            <validation-provider v-slot="v" slim rules="required">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <label class="input-group-text" for="codeGrs">{{
                    $t("customer.codeGrs")
                  }}</label>
                </div>
                <input
                  id="codeGrs"
                  type="text"
                  name="codeGrs"
                  :value="order.addressForm.codeGRS"
                  class="form-control"
                  :class="{
                    'is-invalid': v.errors.length,
                  }"
                  @input="changeAddressFormCodeGrs($event.target.value)"
                />
              </div>
            </validation-provider>
          </div>
          <div v-if="visibleSubsidiaries" class="col-sm-6 col-12">
            <validation-provider v-slot="v" slim rules="required">
              <div class="input-group-prepend mb-3">
                <label class="input-group-text" for="nameGrs">{{
                  $t("customer.nameGrs")
                }}</label>

                <input
                  class="form-control w-100"
                  maxlength="100"
                  type="text"
                  id="nameGrs"
                  :value="order.addressForm.nameGRS"
                  :class="{
                    'is-invalid': v.errors.length,
                  }"
                  @input="changeAddressFormNameGrs($event.target.value)"
                />
              </div>
            </validation-provider>
          </div>
        </div>
      </div>
    </validation-observer>
    <validation-observer ref="v-observer" class="row ">
      <div v-if="order.specialAddressForm == 'N'" class="col-md-12">
        <div class="row">
          <div class="col-md-3 col-12">
            <div class="input-group-prepend">
              <label
                class="input-group-text order-proposal-shipping"
                for="proposalShipping"
                >{{ $t("customer.selectShippingAddressToOrder") }}</label
              >
            </div>
          </div>
          <div class="col-sm-8 col-12">
            <validation-provider v-slot="v" slim rules="required">
              <multiselect
                id="proposalShipping"
                class="form-control-sm form-control-select textarea"
                :class="{
                  'is-invalid': v.errors.length,
                }"
                :placeholder="$t('buttons.selectAddress')"
                :value="selectedOption"
                :options="selectOptions"
                track-by="id"
                label="name"
                :searchable="true"
                deselectLabel=""
                selectLabel=""
                @input="selectShipment($event)"
              />
            </validation-provider>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-4 col-12">
            <div class="input-group mb-3">
              <label class="input-group-text" for="specialOrder">{{
                $t("orders.specialOrder")
              }}</label>
              <div class="input-group-prepend">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="specialOrder"
                  @change="changeSpecialOrder"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-6 col-12">
            <validation-provider v-slot="v" slim rules="required">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <label class="input-group-text" for="proposalDate">{{
                    $t("basket.proposalDateTime")
                  }}</label>
                </div>
                <input
                  id="proposalDate"
                  type="date"
                  name="proposalDate"
                  :value="order.proposalTime"
                  class="form-control"
                  :class="{
                    'is-invalid': v.errors.length,
                  }"
                  @change="changeProposalTime"
                />
              </div>
            </validation-provider>
          </div>
          <div class="col-sm-6 col-12">
            <div class="input-group-prepend mb-3">
              <label class="input-group-text" for="referenceNumber">{{
                $t("orders.referenceNumber")
              }}</label>

              <input
                class="form-control w-100"
                maxlength="100"
                type="text"
                id="referenceNumber"
                :value="order.referenceNumber"
                @change="changeReferenceNumber"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-12">
        <div class="row">
          <validation-provider v-slot="v" slim rules="required">
            <div class="col-sm-6 col-12 input-group mb-3">
              <div class="input-group-prepend">
                <label class="input-group-text" for="paymentMethodGroup">{{
                  $t("basket.paymentMethod")
                }}</label>
              </div>
              <select
                id="paymentMethodGroup"
                name="paymentMethod"
                class="form-control"
                :disabled="globalRoadSystem"
                :class="{
                  'is-invalid': v.errors.length,
                }"
                :value="payment"
                @change="changePaymentState"
              >
                <option
                  v-for="p in paymentList"
                  :key="p.docEntry"
                  :value="p.docEntry"
                >
                  {{ $t("paymentMethod." + p.docEntry) }}
                </option>
              </select>
            </div>
          </validation-provider>
          <validation-provider v-slot="v" slim rules="required">
            <div class="col-sm-6 col-12 input-group mb-3">
              <div class="input-group-prepend">
                <label class="input-group-text" for="shippingMethodGroup">{{
                  $t("basket.shippingMethod")
                }}</label>
              </div>
              <select
                id="shippingMethodGroup"
                name="shippingMethodGroup"
                class="form-control"
                :class="{
                  'is-invalid': v.errors.length,
                }"
                :value="order.shippingValue"
                @change="changeShippingState"
              >
                <option
                  v-for="s in shippingOption"
                  :key="s.value"
                  :value="s.value"
                >
                  {{ $t("shippingMethod." + s.value).toUpperCase() }}
                </option>
              </select>

              <br />
            </div>
          </validation-provider>
        </div>
      </div>
      <div class="col-sm-12 col-12">
        <div class="row">
          <!-- <validation-provider v-slot="v" slim rules="required">
            <div class="col-sm-6 col-12 input-group mb-3">
              <div class="input-group-prepend">
                <label class="input-group-text" for="transportRequired">{{
                  $t("orders.transportRequired")
                }}</label>
              </div>
              <select
                id="transportRequired"
                name="transportRequired"
                :value="order.requiredTransport"
                class="form-control"
                :class="{
                  'is-invalid': v.errors.length,
                }"
                @change="changeTransportRequired"
              >
                <option value="N">{{ $t("orders.no") }}</option>
                <option value="Y">{{ $t("orders.yes") }}</option>
              </select>
            </div>
          </validation-provider> -->
          <validation-provider v-slot="v" slim rules="required">
            <div class="col-sm-6 col-12 input-group mb-3">
              <div class="input-group-prepend">
                <label class="input-group-text" for="salesOrderReal">{{
                  $t("orders.salesOrderReal")
                }}</label>
              </div>
              <select
                id="salesOrderReal"
                name="salesOrderReal"
                :value="order.salesOrderReal"
                class="form-control"
                :class="{
                  'is-invalid': v.errors.length,
                }"
                @change="changeSalesOrderReal"
              >
                <option value="C">{{ $t("orders.real100") }}</option>
                <option value="Z">{{ $t("orders.whatIsAndToClose") }}</option>
                <option value="P">{{ $t("orders.realizationPart") }}</option>
              </select>
            </div>
          </validation-provider>
          <validation-provider v-slot="v" slim rules="required">
            <div class="col-sm-6 col-12 input-group mb-3">
              <div class="input-group-prepend">
                <label class="input-group-text" for="docToSend">{{
                  $t("orders.docToSend")
                }}</label>
              </div>
              <select
                id="docToSend"
                name="docToSend"
                :value="order.docToSend"
                class="form-control"
                :class="{
                  'is-invalid': v.errors.length,
                }"
                @change="changeDocToSend"
              >
                <option value="W">{{ $t("orders.delivery") }}</option>
                <option value="F">{{ $t("orders.deliveryAndInvoice") }}</option>
              </select>
            </div>
          </validation-provider>
          <div class="col-sm-6 col-12 input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="invoiceForTransport">{{
                $t("orders.invoiceForTransport")
              }}</label>
            </div>
            <validation-provider v-slot="v" rules="required" slim>
              <select
                id="invoiceForTransport"
                :value="order.invoiceForTransport"
                :disabled="globalRoadSystem"
                class="form-control"
                :class="{
                  'is-invalid': v.errors.length,
                }"
                @change="changeInvoiceForTransport"
              >
                <option value="0">{{ $t("orders.no") }}</option>
                <option value="1">{{ $t("orders.yes") }}</option>
                <option value="3">
                  {{ $t("orders.calculateAfterPacking") }}
                </option>
              </select>
            </validation-provider>
            <br />
          </div>
          <div class="col-sm-6 col-12 input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="prepayment">{{
                $t("orders.prepayment")
              }}</label>
            </div>
            <validation-provider v-slot="v" rules="required" slim>
              <select
                id="prepayment"
                :value="order.prepayment"
                class="form-control"
                :class="{
                  'is-invalid': v.errors.length,
                }"
                @change="changePrepayment"
              >
                <option value="N">{{ $t("orders.no") }}</option>
                <option value="Y">{{ $t("orders.yes") }}</option>
              </select>
            </validation-provider>
            <br />
          </div>
          <div class="col-sm-6">
            <div class="input-group-prepend mb-3">
              <label class="input-group-text" for="shippingCity">{{
                $t("orders.shippingCity")
              }}</label>

              <input
                class="form-control w-100"
                maxlength="50"
                type="text"
                id="shippingCity"
                :value="order.shippingCity"
                @change="changeShippingCity"
              />
            </div>
          </div>
          <div v-if="showDocRate" class="col-sm-6">
            <div class="input-group-prepend mb-3">
              <label class="input-group-text" for="docRate">{{
                $t("orders.docRate")
              }}</label>
              <!-- <validation-provider v-slot="v" slim rules="required"> -->
              <input
                class="form-control w-100"
                maxlength="50"
                type="text"
                id="docRate"
                :value="order.docRate"
                @change="changeDocRate"
              />
              <!-- </validation-provider> -->
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-12">
        <div class="row">
          <div class="col-sm-6 col-12 input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="commentsGroup">{{
                $t("basket.comment")
              }}</label>
            </div>
            <textarea
              id="commentsGroup"
              rows="5"
              cols="100"
              class="w-auto"
              :value="order.comment"
              :maxlength="254"
              @change="changeCommentState"
            />
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="col">
          <div class="text-center">
            <button
              class="btn btn-secondary m-1 hideToSummaryBack"
              @click="backStep"
            >
              {{ $t("buttons.backToCustomer") }}
            </button>
            <button
              class="btn btn-theme-add m-1 hideToSummary"
              @click="nextStep"
            >
              {{ $t("buttons.nextStep") }}
            </button>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import { currencyMixin } from "../mixins";
import Multiselect from "vue-multiselect";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { CountryListGus } from "../enums/CountriesAll";
import { StateList } from "../enums/State";
import i18n from "../translations";

export default {
  name: "Checkout",
  components: { ValidationObserver, ValidationProvider, Multiselect, Loading },
  mixins: [currencyMixin],
  data() {
    return {
      shippingOption: [
        { value: "16" },
        { value: "13" },
        { value: "12" },
        { value: "11" },
        // { value: "10" },
        { value: "9" },
        { value: "8" },
        { value: "7" },
        { value: "6" },
        { value: "5" },
        { value: "4" },
        { value: "3" },
        { value: "2" },
        { value: "1" },
      ],
      paymentList: [],
      customerPayment: this.payment,
      isLoading: false,
      fullPage: true,
      globalRoadSystem: false,
      showDocRate: false,
      countryList: CountryListGus,
      locale: i18n.locale,
      provinceList: StateList,
      visibleSubsidiaries: true,
      showDocumentAddressForm: true,
    };
  },
  computed: {
    ...mapState({
      city: (state) => state.cart.order.addressForm.city,
      phone: (state) => state.cart.order.addressForm.phone,
      email: (state) => state.cart.order.addressForm.email,
      addressName: (state) => state.cart.order.addressForm.addressName,
      codeGRS: (state) => state.cart.order.addressForm.codeGRS,
      nameGRS: (state) => state.cart.order.addressForm.nameGRS,
      zipCode: (state) => state.cart.order.addressForm.zipCode,
      country: (state) => state.cart.order.addressForm.country,
      street: (state) => state.cart.order.addressForm.street,
      specialAddressForm: (state) => state.cart.order.specialAddressForm,
    }),
    ...mapState("currency", ["currency", "ratio"]),
    ...mapState("cart", ["order"]),
    ...mapGetters("cart", [
      "totalPrice",
      "transport",
      "currentCustomer",
      "specialOrder",
      "payment",
      "docToSend",
      "salesOrderReal",
      // "specialAddressForm",
      "currentAddressForm",
      "city",
    ]),
    ...mapGetters("auth", ["paymentCustomer"]),
    ...mapGetters("customers", {
      customerShipping: "shipping",
    }),
    selectOptions() {
      let a = [];
      if (this.currentCustomer.cardCode === "O00004") {
        a = [] = this.customerShipping
          ? this.customerShipping.map((shipObject) => ({
              name:
                shipObject.addressName +
                " - " +
                shipObject.city +
                " " +
                shipObject.street +
                " - " +
                shipObject.codeGrs +
                " " +
                shipObject.nameGrs,
              id: shipObject.addressId,
            }))
          : [];
      } else {
        a = [] = this.customerShipping
          ? this.customerShipping.map((shipObject) => ({
              name:
                shipObject.addressName +
                " - " +
                shipObject.city +
                " " +
                shipObject.street,
              id: shipObject.addressId,
            }))
          : [];
      }

      return a;
    },
    selectedOption() {
      return this.selectOptions.find(
        (el) => el.id === this.order.shipping.addressId,
      );
    },
  },
  methods: {
    ...mapActions({
      setCity: "cart/setCity",
      setCountry: "cart/setCountry",
      setStreet: "cart/setStreet",
      setNameGRS: "cart/setNameGrs",
      setCodeGRS: "cart/setCodeGrs",
      setZipCode: "cart/setZipCode",
      setPhone: "cart/setPhone",
      setEmail: "cart/setEmail",
      setAddressName: "cart/setAddressName",
      clearCart: "cart/clearCartData",
      // initAddressForm: "cart/initilizeAddressForm",
    }),
    ...mapMutations("cart", [
      "setPayment",
      "setShipping",
      "setComment",
      "setShippingValue",
      "setProposalTime",
      "setPrepayment",
      "setShippingCity",
      "setDocRate",
      "setTransportRequired",
      "setReferenceNumber",
      "setInvoiceForTransport",
      "setSalesOrderReal",
      "setDocToSend",
      "setSpecialOrder",
      "setStatus",
      "setType",
      "setSpecialAddressForm",
    ]),
    async backStep() {
      this.$router.push({
        name: "customer",
        params: {
          id: this.order.customer.customerId,
        },
      });
    },
    async nextStep() {
      // if (this.validForm() === undefined) {
      //   this.$router.push({ name: "products" });
      // }
      if (this.specialAddressForm == "Y") {
        Promise.all([
          this.$refs["v-observer"].validate(),
          this.$refs["v-observer-address-additional"].validate(),
        ]).then((results) => {
          if (results.every((result) => result)) {
            this.$router.push({ name: "products" });
          }
        });
      } else {
        this.$refs["v-observer"].validate().then(async (result) => {
          if (result) {
            this.$router.push({
              name: "products",
            });
          }
        });
      }
    },
    validForm() {
      if (this.specialAddressForm == "Y") {
        this.$refs["v-observer"].validate().then((result1) => {
          if (!result1) {
            return false;
          }
          this.$refs["v-observer-address-additional"]
            .validate()
            .then((result2) => {
              if (!result2) {
                return false;
              }
              return true;
            });
        });
      } else {
        this.$refs["v-observer"].validate().then(async (result) => {
          if (result) {
            return result;
          }
        });
      }
      // return false;
    },
    changePaymentState: function(event) {
      this.setPayment(event.target.value);
    },
    changeShippingState: function(event) {
      this.setShippingValue(event.target.value);
    },
    changeProposalTime: function(event) {
      this.setProposalTime(event.target.value);
    },
    changePrepayment: function(event) {
      this.setPrepayment(event.target.value);
    },
    changeShippingCity: function(event) {
      this.setShippingCity(event.target.value);
    },
    changeDocRate: function(event) {
      this.setDocRate(event.target.value);
    },
    changeCommentState: function(event) {
      this.setComment(event.target.value);
    },
    changeTransportRequired: function(event) {
      this.setTransportRequired(event.target.value);
    },
    changeInvoiceForTransport: function(event) {
      this.setInvoiceForTransport(event.target.value);
    },
    changeSalesOrderReal: function(event) {
      this.setSalesOrderReal(event.target.value);
    },
    changeDocToSend: function(event) {
      this.setDocToSend(event.target.value);
    },
    changeAddressFormCity: function(value) {
      this.$store.dispatch("cart/setCity", value);
    },
    changeAddressFormStreet: function(value) {
      this.setStreet(value);
    },
    changeAddressFormZipCode: function(value) {
      this.setZipCode(value);
    },
    changeAddressFormPhone: function(value) {
      this.setPhone(value);
    },
    changeAddressFormCountry: function(value) {
      this.setCountry(value);
    },
    changeAddressFormEmail: function(value) {
      this.setEmail(value);
    },
    changeAddressFormCodeGrs: function(value) {
      this.setCodeGRS(value);
    },
    changeAddressFormNameGrs: function(value) {
      this.setNameGRS(value);
    },
    changeAddressFormName: function(value) {
      this.setAddressName(value);
    },
    changeSpecialOrder: function(event) {
      if (event.target.checked) {
        this.setSpecialOrder("Y");
      } else {
        this.setSpecialOrder("N");
      }
    },
    changeSpecialAddressForm: function(event) {
      if (event.target.checked) {
        this.setSpecialAddressForm("Y");
      } else {
        this.setSpecialAddressForm("N");
      }
    },
    changeReferenceNumber: function(event) {
      this.setReferenceNumber(event.target.value);
    },
    selectShipment(value) {
      this.isLoading = true;
      this.setShipping(
        this.customerShipping.find(
          (shipObject) => shipObject.addressId === value.id,
        ),
      );
      this.isLoading = false;
    },
    filterPayment: function(event) {
      const customerPayment = this.$store.getters["auth/paymentCustomer"];
      const displayPayments = this.$store.getters["auth/paymentList"];
      const payments = displayPayments.filter(function(payment) {
        if (
          ["-1", "4", "8", "10", customerPayment].includes(payment.docEntry)
        ) {
          return payment;
        }
      });
      this.paymentList = payments;
    },
    checkPayment: function(event) {
      if (this.$store.getters["cart/payment"] == "") {
        this.setPayment(this.paymentCustomer);
      }
    },
    checkDocToSend: function(event) {
      if (this.$store.getters["cart/docToSend"] == "") {
        this.setDocToSend(this.currentCustomer.defaultDocSend);
      }
    },
    checkSalesOrderReal: function(event) {
      if (this.$store.getters["cart/salesOrderReal"] == "") {
        this.setSalesOrderReal(this.currentCustomer.defaultZSReal);
      }
    },
    checkSpecialOrder: function(event) {
      if (this.$store.getters["cart/specialOrder"] == "Y") {
        document.getElementById("specialOrder").checked = true;
      } else {
        document.getElementById("specialOrder").checked = false;
      }
    },
    checkSpecialAddressForm: function(event) {
      if (this.$store.getters["cart/specialAddressForm"] == "Y") {
        document.getElementById("specialAddress").checked = true;
      } else if (document.getElementById("specialAddress")) {
        document.getElementById("specialAddress").checked = false;
      }
    },
    checkInvoiceForTransport: function(event) {
      if (this.globalRoadSystem) {
        this.setInvoiceForTransport("0");
      }
    },
    checkPrePayment: function(event) {
      if (this.globalRoadSystem) {
        this.setPrepayment("N");
      }
    },
    showRate: function(event) {
      if (this.order.type == "invoice" && this.customer.country != "PL") {
        this.showDocRate = true;
      }
    },
  },
  mounted() {
    // this.setSpecialAddressForm("N");
    (this.visibleSubsidiaries = [
      "O00004",
      "O00005",
      "O00009",
      "O99997",
    ].includes(this.currentCustomer.cardCode)
      ? true
      : false),
      (this.showDocumentAddressForm = [
        "O00004",
        "O00005",
        "O00009",
        "DETAL",
        "O16925",
        "O99998",
        "O36530",
        "O56478",
        "O59208",
        "O99997",
      ].includes(this.currentCustomer.cardCode)
        ? true
        : false),
      (this.globalRoadSystem = this.currentCustomer.cardCode === "O00004");

    this.checkDocToSend();
    this.checkSalesOrderReal();
    this.filterPayment();
    this.checkPayment();
    this.checkSpecialOrder();
    this.checkInvoiceForTransport();
    this.checkPrePayment();
    this.showRate();

    // if (this.order.status == "new") {
    //   this.setCity("");
    //   this.setStreet("");
    //   this.setAddressName("");
    //   this.setZipCode("");
    //   this.setCountry("");
    //   this.setPhone("");
    //   this.setCodeGRS("");
    //   this.setNameGRS("");
    //   this.setEmail("");
    // }

    this.checkSpecialAddressForm();

    // this.customerPayment = this.paymentCustomer;
  },
};
</script>
<style scoped>
.form-check-input {
  position: absolute;
  margin-top: 0.3 rem;
  margin-right: 0px;
  width: 32px !important;
  height: 30px !important;
  margin-left: 0px;
}
</style>
